<template>
  <div>
    <header class="header">
      <h1>Blog Posts</h1>
      <router-link class="button" :to="{ name: 'blog-create' }">New</router-link>
    </header>

    <list-table :data="blogs">
      <template slot="thead">
        <th>Name</th>
        <th></th>
      </template>
      <template slot-scope="props">
        <td>
          <router-link :to="{ name: 'blog', params: { slug: props.instance.slug } }">
            <!-- , section: props.instance.section -->
            <small
              v-if="props.instance.show_on_homepage"
              style="color: red; font-style: bolder"
            >(Homepage: {{ props.instance.show_on_homepage == true ? "yes" : "no" }})
            </small>{{ props.instance.title }}
          </router-link>
        </td>
        <td width="100px">
          <remove-item-button apiUrl="blog-posts" v-model="blogs" :id="props.instance.id"></remove-item-button>
        </td>
      </template>
    </list-table>
  </div>
</template>

<script>
import ListTable from '@/components/ListTable'
import RemoveItemButton from '@/components/RemoveItemButton'
export default {
  data () {
    return {
      blogs: []
    }
  },

  components: {
    ListTable,
    RemoveItemButton
  },

  mounted () {
    this.axios.get('blog-posts')
      .then(res => {
        this.blogs = res.data
      })
  }
}
</script>
